import { ReactNode } from "react";

type VacancyDataFieldProps = {
  icon: ReactNode;
  label?: string | null;
  value?: string | null;
};

export const VacancyDataField: React.FC<VacancyDataFieldProps> = ({
  icon,
  label,
  value,
}) => {
  return (
    <div className="flex items-center gap-3">
      <span className="text-muted-foreground">{icon}</span>
      <div className="flex flex-col">
        <span className="text-sm text-muted-foreground">
          {label ? label : "..."}
        </span>
        <span className="text-sm text-foreground">{value ? value : "..."}</span>
      </div>
    </div>
  );
};
